/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */


document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('.program-filter-search-input');
    const searchButton = document.querySelector('.program-filter-search-button');

    let searchTerm = '';

    function matchesSearch(term, text) {
        if (!term) return true;
        return text.includes(term);
    }

    function runSearch() {
        searchTerm = searchInput.value.toLowerCase().trim();
        filterPrograms();

            const results = document.querySelector('#course-results');
        if (results) {
            results.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    if (searchButton && searchInput) {

        searchButton.addEventListener('click', runSearch);

        searchInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                runSearch();
            }
        });
    }
    const programs = document.querySelectorAll('.program-item');

    const filters = {
        location: document.querySelectorAll('.filter-location'),
        length: document.querySelectorAll('.filter-length'),
        faculty: document.querySelectorAll('.filter-faculty'),
        certification: document.querySelectorAll('.filter-certification'),
        postType: document.querySelectorAll('.filter-post-type'),
        status: document.querySelectorAll('.filter-status')
    };

    function getSelected(nodeList) {
        return Array.from(nodeList)
            .filter(cb => cb.checked)
            .map(cb => cb.value);
    }

    function matchesFilter(selected, values) {
        if (selected.length === 0) return true;
        return selected.some(val => values.includes(val));
    }

    function filterPrograms() {
        const selectedLocations = getSelected(filters.location);
        const selectedLengths   = getSelected(filters.length);
        const selectedFaculties = getSelected(filters.faculty);
        const selectedCertifications = getSelected(filters.certification);
        const selectedPostTypes = getSelected(filters.postType);
        const selectedStatus = getSelected(filters.status);

        programs.forEach(program => {
            const locations = (program.dataset.locations || '').split(' ').filter(Boolean);
            const lengths = (program.dataset.lengths || '').split(' ').filter(Boolean);
            const faculties = (program.dataset.faculties || '').split(' ').filter(Boolean);
            const certifications = (program.dataset.certifications || '').split(' ').filter(Boolean);
            const status = (program.dataset.status || '').split(' ').filter(Boolean);

            const postType = program.dataset.postType || '';
            const text = (program.dataset.search || '').toLowerCase();

            const show =
                matchesFilter(selectedLocations, locations) &&
                matchesFilter(selectedLengths, lengths) &&
                matchesFilter(selectedFaculties, faculties) &&
                matchesFilter(selectedCertifications, certifications) &&
                (selectedPostTypes.length === 0 || selectedPostTypes.includes(postType)) &&
                matchesFilter(selectedStatus, status) &&
                matchesSearch(searchTerm, text);

            program.style.display = show ? '' : 'none';
        });
    }

    Object.values(filters).forEach(group => {
        group.forEach(cb => cb.addEventListener('change', filterPrograms));
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const toggleBtn = document.querySelector('.program-filter-toggle');
    const filters = document.querySelector('.program-filter-filters');

    if (!toggleBtn || !filters) return;

    toggleBtn.addEventListener('click', () => {
        filters.classList.toggle('is-open');

        // Optional: change button text
        toggleBtn.textContent = filters.classList.contains('is-open')
            ? 'Hide Filters'
            : 'Show Filters';
        
        // Accessibility
        toggleBtn.setAttribute(
            'aria-expanded',            
            filters.classList.contains('is-open')
        );
    });
});
/* eslint-enable no-console */
